import React from 'react';
import { Input } from 'rsuite';

export const Textarea= React.forwardRef<HTMLTextAreaElement, { rows?: number}>((props, ref) => {
  return <Input {...props} as="textarea" ref={ref} />
});